module.exports = __webpack_public_path__ + "static/fonts/Fact-NarrowLight.816891c.ttf";